var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ScreenBox', _vm.height === '0' ? 'flex' : ''],style:({ height: _vm.height })},[_c('div',{staticClass:"ScreenBox__header"},[_c('div',{staticClass:"title",on:{"click":function($event){return _vm.chartClick(_vm.menuCode)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"ScreenBox__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }